import { FrequencyLimitUnits } from '../dtos/frequency-limit-unit.enum';
import { PartnerCUDto } from '../dtos/partner-cu.dto';

export class PartnerModel {
    private _partner: PartnerCUDto;

    public constructor(partner: PartnerCUDto) {
        this._partner = partner;
    }

    public get organizationId(): number {
        return this._partner.organizationId;
    }

    public get partnerId(): string {
        return this._partner.partnerId;
    }

    /**
     * Law of Dementer violated
     */
    public get partnerName(): string {
        return this._partner.organizationDisplayName;
    }

    public set partnerName(name: string) {
        this._partner.organizationDisplayName = name;
    }

    public get maximumResendLimit(): number {
        return this._partner.resendLimit;
    }

    public set maximumResendLimit(limit: number) {
        this._partner.resendLimit = limit;
    }

    public get maximumResendLimitUnit(): string {
        return this._partner.resendLimitUnits;
    }

    public set maximumResendLimitUnit(limit: string) {
        this._partner.resendLimitUnits = limit;
    }

    public get maximumTestActivationLimit(): number {
        return this._partner.testActivationLimit;
    }

    public set maximumTestActivationLimit(limit: number) {
        this._partner.testActivationLimit = limit;
    }

    public get maximumTestActivationLimitUnit(): string {
        return this._partner.testActivationLimitUnits;
    }

    public set maximumTestActivationLimitUnit(limit: string) {
        this._partner.testActivationLimitUnits = limit;
    }

    public isDefault(): boolean {
        return this._partner.organizationId === PartnerModel.getDefault().organizationId;
    }

    public static getDefault(): PartnerModel {
        return new PartnerModel({
            isTopconPartner: false,
            email: '',
            organizationDisplayName: '',
            partnerId: '',
            resendLimit: 0,
            resendLimitUnits: '',
            testActivationLimit: 0,
            testActivationLimitUnits: '',
            address1: '',
            adminFirstName: '',
            adminLastName: '',
            city: '',
            country: '',
            mobilePhone: '',
            mobilePhoneCountry: '',
            organizationId: 0,
            phone: '',
            state: '',
            taxPayerId: '',
            zipcode: ''
        });
    }

    public getPartnerDto(): PartnerCUDto {
        return { ...this._partner };
    }
}
